import dayjs from 'dayjs';
import 'dayjs/locale/es';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.locale('es');
dayjs.extend(AdvancedFormat);

export default dayjs;